import React from "react";
import { useEffect, useState } from "react";
import {
  CompanyManageSetCompanyStoreAvrageRate,
  ProductFilterProducts,
  CompanyManageGetCompanyStoreAvrageRate,
  CompanyManageMyStore,
  CompanyManageGetProductCompany,
  CompanyManageGetAutoAvrageRate,
  ProductFilterBerand,
} from "../../Api/Services";
import { toast } from "react-toastify";
import imgPlus from "../../assets/Icon/execution.png";
import { confirmAlert } from "react-confirm-alert";
import InputCus from "../../Component/InputCus/Text/InputCus";

function CompanyStoreAvrage() {
  const [isLoading, setLoading] = useState(true);
  const [CompanyStore, setCompanyStore] = useState([]);
  const [Errors, setErrors] = useState([]);
  const [Product, setProduct] = useState([]);
  const [Data, setData] = useState([]);
  const [ProductCompany, setProductCompany] = useState([]);
  const [CompanyStoreId, setCompanyStoreId] = useState();
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [SearchName, setSearchName] = useState("");

  const start = async () => {
    setData([]);
    setProduct([]);
    setCompanyStore([]);
    setCompanyStoreId();
    try {
      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        setCompanyStore(CompanyManageMyStoreData.data.data);
        const ProductFilterBerandData = await ProductFilterBerand({});
        if (
          ProductFilterBerandData.status &&
          ProductFilterBerandData.status === 200
        ) {
          setBrands(ProductFilterBerandData.data.data.data);

          const ProductFilterProductsData = await ProductFilterProducts({});
          if (
            ProductFilterProductsData.status &&
            ProductFilterProductsData.status === 200
          ) {
            setProduct(ProductFilterProductsData.data.data.data);
            let data = [];
            ProductFilterProductsData.data.data.data.forEach((element) => {
              let model = {
                ProductId: element.id,
                Price: 0,
              };
              data.push(model);
            });
            setData(data);

            if (CompanyManageMyStoreData.data.data.length > 0) {
              let id = CompanyManageMyStoreData.data.data[0].companyStoreId;
              let idCompany =
                CompanyManageMyStoreData.data.data[0].companyStoreCompanyId;
              setCompanyStoreId(id);
              const CompanyManageGetCompanyStoreAvrageData =
                await CompanyManageGetCompanyStoreAvrageRate(id);
              if (
                CompanyManageGetCompanyStoreAvrageData.status &&
                CompanyManageGetCompanyStoreAvrageData.status === 200
              ) {
                let data1 = [...data];
                data1.forEach((element) => {
                  element.Price = 0;
                });
                CompanyManageGetCompanyStoreAvrageData.data.data.forEach(
                  (element) => {
                    data1.find((e) => e.ProductId == element.productId).Price =
                      element.price;
                  },
                );
                setData(data1);
                const CompanyManageGetProductCompanyData =
                  await CompanyManageGetProductCompany(idCompany);
                if (
                  CompanyManageGetProductCompanyData.status &&
                  CompanyManageGetProductCompanyData.status === 200
                ) {
                  setProductCompany(
                    CompanyManageGetProductCompanyData.data.data,
                  );
                }
              }
            }
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Add = async () => {
    setLoading(true);
    try {
      let model = {
        CompanyStoreId: CompanyStoreId,
        Product: Data,
      };
      const CompanyManageSetCompanyStoreAvrageData =
        await CompanyManageSetCompanyStoreAvrageRate(model);
      if (
        CompanyManageSetCompanyStoreAvrageData.status &&
        CompanyManageSetCompanyStoreAvrageData.status === 200
      ) {
        toast.success("ثبت اطلاعات  با موفقیت انجام شد");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error);
    } finally {
      start();
    }
  };

  const setStore = async (id, idCompany) => {
    setCompanyStoreId(id);
    setLoading(true);
    try {
      const CompanyManageGetCompanyStoreAvrageData =
        await CompanyManageGetCompanyStoreAvrageRate(id);
      if (
        CompanyManageGetCompanyStoreAvrageData.status &&
        CompanyManageGetCompanyStoreAvrageData.status === 200
      ) {
        let data = [...Data];
        data.forEach((element) => {
          element.Price = 0;
        });
        CompanyManageGetCompanyStoreAvrageData.data.data.forEach((element) => {
          data.find((e) => e.ProductId == element.productId).Price =
            element.price;
        });
        setData(data);
        const CompanyManageGetProductCompanyData =
          await CompanyManageGetProductCompany(idCompany);
        if (
          CompanyManageGetProductCompanyData.status &&
          CompanyManageGetProductCompanyData.status === 200
        ) {
          setProductCompany(CompanyManageGetProductCompanyData.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeSearch = (id, e) => {
    const newForm = [...Data];
    newForm.find((e) => e.ProductId == id).Price = e.target.value.replaceAll(
      ",",
      "",
    );
    setData(newForm);
  };

  const confirmAuto = (e) => {
    confirmAlert({
      title: "بروزرسانی اتوماتیک نرخ میانگین",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => AutoItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const AutoItem = async (e) => {
    try {
      setLoading(true);
      const CompanyManageGetAutoAvrageRateData =
        await CompanyManageGetAutoAvrageRate(e);
      if (
        CompanyManageGetAutoAvrageRateData.status &&
        CompanyManageGetAutoAvrageRateData.status === 200
      ) {
        setErrors(CompanyManageGetAutoAvrageRateData.data.data);

        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  const groupProducts = (products) => {
    const groups = {};
    products.forEach((p) => {
      const key = [
          p.productBerandId,
          p.productTypeId,
          p.productSeriesId,
          p.symbol,
          p.productSeriesEndId,
          p.productRamId,
          p.productRomId,
          p.productNetworkId,
          p.productCountryId,
          p.isInsurance,
      ].join("-");
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(p);
    });
    return Object.values(groups);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-center align-item-center flex-column">
            {Errors.map((item) => (
              <p>{item}</p>
            ))}
          </div>
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
            <div className="d-flex justify-content-between align-items-center">
              {CompanyStore &&
                CompanyStore.map((item, key) => (
                  <div className="border border-3 border-black m-2 rounded">
                    {item.companyStoreCompanyWarehouseType && (
                      <button
                        className={`m-2 border-0 rounded ${
                          item.companyStoreCompanyWarehouseType &&
                          "bg-warning pointer"
                        }`}
                        onClick={() => {
                          confirmAuto(item.companyStoreId);
                        }}
                      >
                        <img height={40} src={imgPlus} alt="" />
                      </button>
                    )}
                    <button
                      onClick={() => {
                        setStore(
                          item.companyStoreId,
                          item.companyStoreCompanyId,
                        );
                      }}
                      className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                        CompanyStoreId == item.companyStoreId
                          ? "bg-warning"
                          : ""
                      }`}
                    >
                      {item.companyStoreCompanyName +
                        " ( " +
                        item.companyStoreName +
                        " ) "}
                    </button>
                  </div>
                ))}
            </div>
            {CompanyStoreId && (
              <div className="w-100">
                <div className="d-flex justify-content-start align-items-center w-100 m-5">
                  <button onClick={Add} className="butAU">
                    ثبت
                  </button>
                </div>
                <InputCus
                  className="m-2"
                  type="text"
                  name="name"
                  id="name"
                  text="نام"
                  value={SearchName}
                  onChange={(e) => {
                    setSearchName(e.target.value);
                  }}
                />
                {brands.map(
                  (b, key) =>
                    Product.filter((e) => e.productBerandId == b.id).length >
                      0 && (
                      <>
                        <div
                          key={b}
                          className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                          onClick={() => handleClick(b.id)}
                        >
                          <h5>{b.name}</h5>
                        </div>
                        {activeItem === b.id && (
                          <div className="d-flex justify-content-center align-items-center w-100 tableC">
                            <table
                              className="table tableMore"
                              style={{ lineHeight: "normal" }}
                            >
                              <thead className="sticky-header">
                                <tr className="trTable">
                                  <th>نام کالای</th>
                                  <th>رنگ</th>
                                  <th>کد کالا در شرکت</th>
                                  <th>نرخ میانگین</th>
                                </tr>
                              </thead>

                              {Product &&
                                groupProducts(Product).map((group, gIndex) => (
                                  <tbody key={gIndex}>
                                    {group
                                      .filter((e) => e.productBerandId == b.id)
                                      .filter((itemPro) => {
                                        const productFilter =
                                          SearchName?.toUpperCase?.() || "";
                                        const Pro =
                                          (
                                            (itemPro.productTypeName != " " &&
                                              itemPro.productTypeName + " ") +
                                            (itemPro.productSeriesName != " " &&
                                              itemPro.productSeriesName) +
                                            itemPro.symbol +
                                            (itemPro.productSeriesEndName != " "
                                              ? itemPro.productSeriesEndName +
                                                " "
                                              : " ") +
                                            (itemPro.productRamName != " " &&
                                              itemPro.productRamName + "/") +
                                            (itemPro.productRomName != " " &&
                                              itemPro.productRomName + " ") +
                                            (itemPro.productNetworkName !=
                                              " " &&
                                              itemPro.productNetworkName +
                                                " ") +
                                            (itemPro.productCountryName !=
                                              " " &&
                                              itemPro.productCountryName +
                                                " ") +
                                            (itemPro.isInsurance && "بیمه")
                                          )?.toUpperCase?.() || "";
                                        return Pro.includes(productFilter);
                                      })
                                      .map((itemPro, iIndex) => {
                                        return (
                                          <tr key={itemPro.id}>
                                            {iIndex === 0 && (
                                              <>
                                                <td rowSpan={group.length}>
                                                  {itemPro.productTypeName !=
                                                    " " &&
                                                    itemPro.productTypeName +
                                                      " "}
                                                  {itemPro.productSeriesName !=
                                                    " " &&
                                                    itemPro.productSeriesName}
                                                  {itemPro.symbol}
                                                  {itemPro.productSeriesEndName !=
                                                  " "
                                                    ? itemPro.productSeriesEndName +
                                                      " "
                                                    : " "}
                                                  {itemPro.productRamName !=
                                                    " " &&
                                                    itemPro.productRamName +
                                                      "/"}
                                                  {itemPro.productRomName !=
                                                    " " &&
                                                    itemPro.productRomName +
                                                      " "}
                                                  {itemPro.productNetworkName !=
                                                    " " &&
                                                    itemPro.productNetworkName +
                                                      " "}
                                                  {itemPro.productCountryName !=
                                                    " " &&
                                                    itemPro.productCountryName +
                                                      " "}
                                                  {itemPro.isInsurance &&
                                                    "بیمه"}
                                                </td>
                                              </>
                                            )}
                                            <td>
                                              {" "}
                                              {itemPro.productColorName}{" "}
                                            </td>
                                            <td>
                                              {
                                                ProductCompany.find(
                                                  (e) =>
                                                    e.productId == itemPro.id,
                                                )?.code
                                              }
                                            </td>
                                            <td>
                                              <input
                                                disabled={
                                                  ProductCompany.find(
                                                    (e) =>
                                                      e.productId == itemPro.id,
                                                  ) == null
                                                }
                                                onChange={(e) => {
                                                  handleChangeSearch(
                                                    itemPro.id,
                                                    e,
                                                  );
                                                }}
                                                value={Data.find(
                                                  (e) =>
                                                    e.ProductId == itemPro.id,
                                                )
                                                  ?.Price.toString()
                                                  .replace(
                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                    ",",
                                                  )}
                                              />
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                ))}
                            </table>
                          </div>
                        )}
                      </>
                    ),
                )}
                <div className="d-flex justify-content-start align-items-center w-100 m-5">
                  <button onClick={Add} className="butAU">
                    ثبت
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default CompanyStoreAvrage;
